import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  FinancialItemService} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { BranchSettingsSelectors } from '../../modules/branch-settings/branch-settings-controller/selectors';
import { BranchSettingsStates } from '../../modules/branch-settings/branch-settings-controller/states';

@Component({
  selector: 'app-util-select-default-settlement-method',
  templateUrl: './select-default-settlement-method.component.html',
  styleUrls: ['./select-default-settlement-method.component.css']
})

export class SelectDefaultSettlementItemComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  @Input() defaultSettlement = new FormControl();
  @Input() settlementMethodType: string;
  @Input() branchGuid: any;
  @Output() defaultSettlementSelected = new EventEmitter<any>();
  @Output() defaultSettlementChange = new EventEmitter<FormControl>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  defaultSettlementList: any[] = [];
  selectedDefaultSettlement: any;
  filterControl = new FormControl();
  protected _onDestroy = new Subject<void>();

  constructor(
    private readonly store: Store<BranchSettingsStates>,
  ) {
  }

  ngOnInit() {
   this.subs.sink = this.store.select(BranchSettingsSelectors.selectBranchSettlementMethodList)
    .subscribe((result) => {
      const filteredArray = result.filter(item => item.settlementType === this.settlementMethodType);
      this.defaultSettlementList = filteredArray;
      this.filteredOptions$.next(this.defaultSettlementList);
    })

    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterDefaultSettlement(resolve)});
  }

  filterDefaultSettlement(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.defaultSettlementList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.defaultSettlementList.filter(c =>
        c.code.toLowerCase().indexOf(search) > -1 ||
        c.name.toLocaleLowerCase().includes(search)
      );
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(guid: string) {
    if (guid) {
      this.defaultSettlement.patchValue(guid);
      this.selectedDefaultSettlement = this.defaultSettlementList.find(n => n.guid === guid);
      this.defaultSettlementSelected.emit(this.selectedDefaultSettlement);
    }
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
